<template>
  <div class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
      <v-aside>
        <template v-slot:tokenProgress>
          <div
              @click="showModal"
              id="percent"
              class="progress-bar cursor-pointer"
              :style="'background: radial-gradient(closest-side, white 79%, transparent 80%), conic-gradient('+token.color.main+' '+token.percent+'%, '+token.color.bg+' 0); color:'+token.color.main+''">
            <span title="Процент">{{token.percent <= 0 ? '' : token.percent}}</span>
          </div>
        </template>
      </v-aside>
      <div id="kt_wrapper" class="wrapper d-flex flex-column flex-row-fluid">
        <v-header/>
        <div id="kt_content" class="content d-flex flex-column flex-column-fluid justify-content-between">
          <div class="container-xxl" id="kt_content_container">
            <router-view :key="$route.fullPath"/>
          </div>
        </div>
        <v-footer/>
      </div>
    </div>
  </div>
  <token-refresh-modal :token="token"/>
  <versions-modal/>
  <custom-notification/>
</template>
<script>
  import CustomNotification from "@/components/Main/CustomNotification.vue";
  import TokenRefreshModal  from '@/components/Modals/TokenRefreshModal'
  import VersionsModal      from '@/components/Modals/VersionsModal'
  import AlertMain          from '@/components/Main/AlertMain'
  import VFooter            from '@/components/Main/VFooter'
  import VHeader            from '@/components/Main/VHeader'
  import VAside             from '@/components/Main/VAside'
  import crypto             from '@/helpers/crypto'

  export default {
    name: 'MainLayout',
    components: {AlertMain, CustomNotification, VersionsModal, TokenRefreshModal, VHeader, VFooter, VAside},
    data () {
      return {
        token: {
          countDownDate: null,
          interval:      null,
          distance:      null,
          percent:       0,
          color:         {main: '#03a9f4', bg: '#afe1f8'},
          ttl:           0,
          sec:           0
        },
        hasTerminal: true
      }
    },
    computed: {
      getUser() {
        return this.$store.state.user
      },
    },
    mounted() {
      if (localStorage.getItem('user')) {
        this.$store.dispatch("userRequest", JSON.parse(crypto.decrypt(localStorage.getItem('user'))));
      }
      this.token.ttl = localStorage.getItem('ttl') ? parseInt(localStorage.getItem('ttl')) : null
      this.tokenTimer()
      this.$store.dispatch('agreementsRequest');
    },
    methods: {
      tokenTimer() {
        if (this.token.ttl) {
          this.token.distance++
          this.token.countDownDate  = new Date(localStorage.getItem('ttlDate')).getTime()
          this.token.interval       = setInterval(() => {
            if (this.token.sec < 0) {
              clearInterval(this.token.interval)
              this.token.percent = 0
              this.clearTokenInfo()
              this.clearStorage()
            } else {
              const now           = new Date().getTime();
              this.token.distance = this.token.countDownDate - now;
              this.token.sec      = Math.floor(this.token.distance / 1000);
              this.token.percent  = Math.floor(((this.token.sec / this.token.ttl) * 100))
              if (this.token.percent > 20) this.token.color = {main: '#03a9f4', bg: '#afe1f8'}
              if (this.token.percent <= 20 && this.token.percent > 3) this.token.color = {main: '#ff9800', bg: '#ffcc80'}
              if (this.token.percent <= 3) this.token.color = {main: '#f44336', bg: '#ef9a9a'}
              if (this.token.sec === 300) {
                this.modalHidden()
                setTimeout(() => {new bootstrap.Modal('#tokenRefreshModal', {}).show()}, 100)
              }
            }
          }, 1000)
        }
      },
      showModal() {
        new bootstrap.Modal('#tokenRefreshModal', {}).show()
      },
      clearTokenInfo() {
        this.token.countDownDate  = null
        this.token.interval       = null
        this.token.distance       = null
        this.token.percent        = 0
        this.token.color          = {main: '#03a9f4', bg: '#afe1f8'}
        this.token.ttl            = 0
        this.token.sec            = 0
      },
      clearStorage() {
        localStorage.removeItem('access')
        localStorage.removeItem('ttl')
        localStorage.removeItem('user')
        localStorage.removeItem('ttlDate')
        window.location.href = '/login'
      },
      modalHidden() {
        const myModalEl = document.getElementById('tokenRefreshModal');
        const modal     = bootstrap.Modal.getInstance(myModalEl);
        if (modal) modal.hide()
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          document.title = to.meta.title || 'Агент';
        }
      },
    }
  }
</script>
<style>
  .progress-bar {
    background: radial-gradient(closest-side, white 79%, transparent 80%), conic-gradient(#afe1f8 100%, #afe1f8 0);
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    transition: .5s;
    font-size: 10px;
    color: #03a9f4;
    display: flex;
    height: 30px;
    width: 30px;
  }
  .progress-bar small {
    font-size: 8px;
  }
</style>